import router from '@/router';
import { toast } from 'vue3-toastify';

export const navigateTo = (path: string) => {
    router.push(path);
};

export const navigateToWithSuccessToast = (path: string, translation) => {
    router.push(path);
    setTimeout(() => {
        toast.success(translation);
    }, 1);
};

export const navigateToWithErrorToast = (path: string, translation) => {
    router.push(path);
    setTimeout(() => {
        toast.error(translation);
    }, 1);
};
